export const CART_ADDITIONAL_FIELDS_FEATURE = 'CART_ADDITIONAL_FIELDS_FEATURE';
